export const getErrorCodeForFetch = (error: any): number => {
  if (error.statusCode) {
    return error.statusCode;
  }

  if (error.status) {
    return error.status;
  }

  // Fallback to message parsing if statusCode is not available
  // If it's not 404 and we don't know exact code return 503 for all of them
  // Treat 503 as default generic error
  return (error as Error)?.message?.includes('404') ? 404 : 503;
};
